// src/components/home/HowItWorksSection.js
import React from 'react';
import './HowItWorksSection.css';

const HowItWorksSection = () => {
  const steps = [
    {
      icon: '🔌',
      title: 'Connect Your Open Dental',
      description: 'Simple API integration—no software installation required. We sync with your existing Open Dental setup in minutes.'
    },
    {
      icon: '🌐',
      title: 'Patients Book Online',
      description: 'Your patients visit your custom booking page 24/7. They see real-time availability and book instantly from any device.'
    },
    {
      icon: '⚡',
      title: 'Instant Sync to Open Dental',
      description: 'Appointments appear in Open Dental immediately. No delays, no manual entry, no double-booking. Just seamless integration.'
    }
  ];

  return (
    <section className="how-it-works-section" id="how-it-works">
      <div className="how-it-works-container">
        <div className="section-header">
          <h2 className="section-title">How It Works</h2>
          <p className="section-subtitle">
            Get up and running in less than 10 minutes—no IT team required
          </p>
        </div>

        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={index} className="step-card">
              <div className="step-number">{index + 1}</div>
              <div className="step-icon">{step.icon}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="how-it-works-cta">
          <a href="/register" className="btn-primary">Start Your Free Trial</a>
          <a href="/dentistjunobeach" className="btn-secondary">See Live Demo</a>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;